export default __webpack_public_path__ + "static/step_4_en-3cc320d0c184de25ca64485117599581.svg";